import {
  ClinicalImpressionAssessmentValueCode,
  ClinicalImpressionCode,
  ClinicalImpressionLocationCode,
  ClinicalImpressionPlanValueCode,
} from '@quromedical/fhir-common';
import type { LocaleStringKey } from 'strings';

export const codeDisplayMap: Record<ClinicalImpressionCode, LocaleStringKey> = {
  [ClinicalImpressionCode.ClinicalUpdate]: 'SOAPNoteCodeClinicalUpdate',
  [ClinicalImpressionCode.Routine]: 'SOAPNoteCodeRoutine',
  [ClinicalImpressionCode.Onboarding]: 'SOAPNoteCodeOnboarding',
  [ClinicalImpressionCode.Authorization]: 'SOAPNoteCodeAuthorization',
  [ClinicalImpressionCode.ClinicalCallout]: 'SOAPNoteCodeClinicalCallout',
  [ClinicalImpressionCode.Discharge]: 'SOAPNoteCodeDischarge',
  [ClinicalImpressionCode.BloodResults]: 'SOAPNoteCodeBloodResults',
  [ClinicalImpressionCode.Physiotherapy]: 'SOAPNoteCodePhysiotherapy',
  [ClinicalImpressionCode.Handover]: 'SOAPNoteCodeHandover',
  [ClinicalImpressionCode.DailySummary]: 'SOAPNoteDailySummary',
  [ClinicalImpressionCode.OverallSummary]: 'SOAPNoteOverallSummary',
  [ClinicalImpressionCode.PreOnboarding]: 'SOAPNotePreOnboarding',
};

export const locationDisplayMap: Record<
  ClinicalImpressionLocationCode,
  LocaleStringKey
> = {
  [ClinicalImpressionLocationCode.Virtual]: 'SOAPNoteLocationCodeVirtual',
  [ClinicalImpressionLocationCode.InPerson]: 'SOAPNoteLocationCodeInPerson',
};

export const assessmentDisplayMap: Record<
  ClinicalImpressionAssessmentValueCode,
  LocaleStringKey
> = {
  [ClinicalImpressionAssessmentValueCode.Stable]: 'SOAPNoteAssessmentStable',
  [ClinicalImpressionAssessmentValueCode.Improving]:
    'SOAPNoteAssessmentImproving',
  [ClinicalImpressionAssessmentValueCode.Deteriorating]:
    'SOAPNoteAssessmentDeteriorating',
  [ClinicalImpressionAssessmentValueCode.Demised]: 'SOAPNoteAssessmentDemised',
};

export const planDisplayMap: Record<
  ClinicalImpressionPlanValueCode,
  LocaleStringKey
> = {
  [ClinicalImpressionPlanValueCode.Continue]: 'SOAPNotePlanContinue',
  [ClinicalImpressionPlanValueCode.Amend]: 'SOAPNotePlanAmend',
  [ClinicalImpressionPlanValueCode.Escalate]: 'SOAPNotePlanEscalate',
  [ClinicalImpressionPlanValueCode.Discharge]: 'SOAPNotePlanDischarge',
  [ClinicalImpressionPlanValueCode.UpgradedToHAH]: 'SOAPNotePlanUpgradedToHAH',
  [ClinicalImpressionPlanValueCode.DeclinedOnboarding]:
    'SOAPNotePlanDeclinedOnboarding',
};
